<template>
	<app-dialog v-slot="{ close }" require-action class="app-confirm-dialog">
		<div class="app-confirm-dialog__inner-content">
			<p class="app-confirm-dialog__message">
				{{ message }}
			</p>

			<div class="app-confirm-dialog__buttons">
				<base-button
					class="app-confirm-dialog__button app-confirm-dialog__button--cancel"
					tabindex="1"
					v-bind="cancelProps"
					@click="action('cancel', close)"
				>
					{{ cancelLabel }}
				</base-button>

				<base-button
					class="app-confirm-dialog__button app-confirm-dialog__button--confirm"
					tabindex="2"
					v-bind="confirmProps"
					@click="action('confirm', close)"
				>
					{{ confirmLabel }}
				</base-button>
			</div>
		</div>
	</app-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import AppDialog from './AppDialog.vue';

export default defineComponent({
	components: {
		AppDialog,
	},

	props: {
		message: {
			type: String,
			required: true,
		},

		cancelLabel: {
			type: String,
			default: 'Cancel',
		},

		confirmLabel: {
			type: String,
			default: 'Confirm',
		},

		cancelProps: {
			type: Object,
			default: () => ({}),
		},

		confirmProps: {
			type: Object,
			default: () => ({}),
		},
	},

	emits: ['cancel', 'confirm', 'close'],

	methods: {
		action(actionName: 'cancel' | 'confirm', close: () => void) {
			this.$emit(actionName);
			close();
		},
	},
});
</script>

<style lang="scss">
.app-confirm-dialog {
	&__inner-content {
		width: 100%;
	}

	&__message {
		@include heading-2;
		margin-bottom: 8rem;
		color: $color-gray;
		word-break: break-word;

		@include max-lg-and-portrait {
			font-size: 3.2rem;
		}
	}

	&__buttons {
		display: flex;
		justify-content: space-between;
		width: 100%;
	}

	&__button {
		width: 14rem;
		padding-right: 1.6rem;
		padding-left: 1.6rem;
	}
}
</style>
